// ** React Imports
import { lazy } from 'react';

const OrderRoutes = [
  {
    path: 'orders/generate-invoice/:id',
    component: lazy(() => import('components/check')),
  },
  {
    path: 'orders/:id/track',
    component: lazy(() =>
      import('views/order-management/orders/OrderTrackPage'),
    ),
  },
  {
    path: 'orders',
    component: lazy(() =>
      import('views/order-management/orders/OrderListPage'),
    ),
  },
  {
    path: 'order/details/:id',
    component: lazy(() =>
      import('views/order-management/orders/OrderDetailsPage'),
    ),
  },
];

export default OrderRoutes;
